import { Alert } from "react-bootstrap";

export const PageMessage = (props:any) => {

  const {
    text
  } = props;

  return (
    <Alert variant='warning' style={{textAlign:'center'}}>
      {text}
    </Alert>
  );

}